import { ROUTE_NAME_PLATFORM_MY_PLANNING_AGENT } from '@/router/platform'
import { devLog } from '@/utils/index'
import router from '@/router'
import store from '@/store'
import { ACCOUNT_RIGHT_LIST_REQUESTS } from '@/consts/rights'

export function isMyPlanning () {
  return this.$route.name === ROUTE_NAME_PLATFORM_MY_PLANNING_AGENT
}

/**
 * Wrap la fonction router.push pour éliminer les erreurs de route duplicated
 * @param location
 * @return {Promise}
 */
export const routerPush = async (location) => {
  try {
    await router.push(location)
  } catch (e) {
    devLog('error', 'Erreur lors de la navigation', e)
  }
}

/**
 * Récupère le nombre de demandes non lues
 * @returns {*}
 */
export const routeBadgeRequestUnread = () => _.get(
  store.state.user,
  [
    'agency',
    'agentRequestUnread',
    store.getters['user/isGranted'](ACCOUNT_RIGHT_LIST_REQUESTS)
      ? 'agencyUnread'
      : 'selfUnread'
  ],
  0)
